export default {
  fields: {
    sales: {
      label: 'Ventas',
    },
    gift_cards_sales: {
      label: 'Ventas de tarjetas regalo',
    },
    average_order_value: {
      label: 'Valor medio de pedido',
    },
    savings: {
      label: 'Ahorro en comisiones de terceros',
    },
    reservations: {
      label: 'Reservas',
    },
    sales_from_email: {
      label: 'Ventas por correo',
    },
    sales_from_google_seo: {
      label: 'Ventas por Google SEO',
    },
    sales_from_google_business_profile: {
      label: 'Ventas por Google Business',
    },
    sales_from_google_ads: {
      label: 'Ventas por Google Ads',
    },
    sales_from_flyers: {
      label: 'Ventas por folletos',
    },
    sales_from_social_media: {
      label: 'Ventas por redes sociales',
    },
    sales_from_facebook_ads: {
      label: 'Ventas por Facebook Ads',
    },
    tips: {
      label: 'Propinas',
    },
    new_customers: {
      label: 'Nuevos clientes',
    },
    returning_customers: {
      label: 'Clientes recurrentes',
    },
    new_visitors: {
      label: 'Nuevos visitantes',
    },
    new_followers: {
      label: 'Nuevos seguidores',
    },
    total_followers: {
      label: 'Total de seguidores',
    },
    delivered_messages: {
      label: 'Mensajes entregados',
    },
    average_open_rate: {
      label: 'Tasa media de apertura de correo',
    },
    average_click_rate: {
      label: 'Tasa media de clics',
    },
    website_visitors_from_email: {
      label: 'Visitantes web por correo',
    },
    sales_from_google_business: {
      label: 'Ventas por Google Business',
    },
    total_reservations: {
      label: 'Reservas',
    },
    website_visitors_from_google_seo: {
      label: 'Clics web desde Google SEO',
    },
    website_clicks_from_google_business: {
      label: 'Clics web desde Google Business',
    },
    website_visitors_from_google_ads: {
      label: 'Clics web desde Google Ads',
    },
    website_visitors_from_social_media: {
      label: 'Clics web desde redes sociales',
    },
    calls_from_google_ads: {
      label: 'Llamadas desde Google Ads',
    },
    directions_from_google_ads: {
      label: 'Indicaciones desde Google Ads',
    },
    google_seo_orders_count: {
      label: 'Google SEO',
    },
    google_business_orders_count: {
      label: 'Google Business',
    },
    google_ads_orders_count: {
      label: 'Google Ads',
    },
    facebook_ads_orders_count: {
      label: 'Facebook Ads',
    },
    social_media_orders_count: {
      label: 'Redes sociales',
    },
    flyer_orders_count: {
      label: 'Folletos',
    },
    email_orders_count: {
      label: 'Correos',
    },
    other_orders_count: {
      label: 'Otros',
    },
    gmv: {
      label: 'GMV',
    },
    gift_cards_gmv: {
      label: 'Tarjetas regalo',
    },
    net_billed_revenue: {
      label: 'Ingresos facturados (NETO)',
    },
    net_billed_revenue_subscription: {
      label: 'Ingresos de suscripción facturados',
    },
    net_billed_revenue_service_fee: {
      label: 'Ingresos de tarifa de servicio facturados',
    },
    net_billed_revenue_external_delivery_platform_fee: {
      label: 'Ingresos facturados por tarifa de entrega',
    },
    net_billed_revenue_other: {
      label: 'Ingresos facturados por cargos de servicio',
    },
    net_billed_revenue_external_delivery_passthrough_fee: {
      label: 'Entrega facturada - Traspaso',
    },
    net_billed_revenue_platform_processing_fee: {
      label: 'Ingresos facturados por tarifa de procesamiento',
    },
    gross_cash_income: {
      label: 'Ingresos en efectivo (bruto)',
    },
    gross_cash_income_subscription: {
      label: 'Ingresos en efectivo por suscripciones',
    },
    gross_cash_income_service_fee: {
      label: 'Ingresos en efectivo por tarifas de servicio',
    },
    gross_cash_income_external_delivery_platform_fee: {
      label: 'Ingresos en efectivo por tarifas de entrega',
    },
    gross_cash_income_other: {
      label: 'Ingresos en efectivo por cargos de servicio',
    },
    gross_cash_income_external_delivery_passthrough_fee: {
      label: 'Ingresos en efectivo por tarifas de entrega traspasadas',
    },
    gross_cash_income_platform_processing_fee: {
      label: 'Ingresos en efectivo por tarifas de procesamiento',
    },
    net_cash_income: {
      label: 'Ingresos en efectivo (neto)',
    },
    net_cash_income_subscription: {
      label: 'Ingresos en efectivo por suscripciones',
    },
    net_cash_income_service_fee: {
      label: 'Ingresos en efectivo por tarifas de servicio',
    },
    net_cash_income_external_delivery_platform_fee: {
      label: 'Ingresos en efectivo por tarifas de entrega',
    },
    net_cash_income_other: {
      label: 'Ingresos en efectivo por cargos de servicio',
    },
    net_cash_income_external_delivery_passthrough_fee: {
      label: 'Ingresos en efectivo por tarifas de entrega traspasadas',
    },
    net_cash_income_platform_processing_fee: {
      label: 'Ingresos en efectivo por tarifas de procesamiento',
    },
    manual_connect_transfers: {
      label: 'Reembolsado a restaurantes',
    },
    processing_fees: {
      label: 'Tarifas de procesamiento',
    },
    processing_fees_stripe: {
      label: 'Tarifas de procesamiento (Stripe)',
    },
    processing_fees_paypal: {
      label: 'Tarifas de procesamiento (PayPal)',
    },
    rejected_orders: {
      label: 'Pedidos rechazados',
    },
    rejected_orders_amount: {
      label: 'Importe de pedidos rechazados',
    },
    rejected_orders_count: {
      label: 'Cantidad de pedidos rechazados',
    },
    rejected_orders_rate: {
      label: 'Tasa de pedidos rechazados',
    },
    rejected_orders_rate_breakdown: {
      label: 'Desglose de tasa de pedidos rechazados',
    },
    orders: {
      label: 'Pedidos',
    },
    total_orders: {
      label: 'Total de pedidos',
    },
    pickup_orders_rate: {
      label: 'Tasa de pedidos para recoger',
    },
    delivery_orders_rate: {
      label: 'Tasa de pedidos a domicilio',
    },
    other_orders_rate: {
      label: 'Tasa de otros pedidos',
    },
    customers: {
      label: 'Total de clientes',
    },
    customers_auth_state: {
      label: 'Estado de autenticación del cliente',
    },
    website_reservations: {
      label: 'Reservas en sitio web',
    },
    google_reservations: {
      label: 'Reservas de Google',
    },
    companies: {
      label: 'Empresas',
    },
    live_companies: {
      label: 'Restaurantes activos',
    },
    live_companies_percentage: {
      label: 'Porcentaje de restaurantes activos',
    },
    setup_packages_breakdown: {
      label: 'Paquetes de configuración',
    },
    setup_packages_billing_mode_breakdown: {
      label: 'Paquetes de configuración por fuente de facturación',
    },
    crossed_sales_level_this_month: {
      label: 'Nivel de ventas superado este mes',
    },
    crossed_sales_level_total: {
      label: 'Nivel de ventas superado total',
    },
    crossed_sales_level_percentage: {
      label: 'Porcentaje de nivel de ventas superado',
    },
    has_delivery: {
      label: 'Entrega propia',
    },
    has_only_pickup: {
      label: 'Solo recogida',
    },
    has_storefront: {
      label: 'Tiene tienda en línea',
    },
    has_storefront_percentage: {
      label: 'Porcentaje de tienda en línea',
    },
    use_external_delivery: {
      label: 'Entrega externa',
    },
    crossed_sales: {
      label: 'Superadas {{value}} ventas',
    },
    restaurant_partners: {
      label: 'Restaurantes asociados',
    },
    registered_restaurants: {
      label: 'Restaurantes registrados',
    },
    signed_restaurants: {
      label: 'Restaurantes firmados',
    },
    use_reservations: {
      label: 'Usa reservas',
    },
    number: {
      label: 'Número',
    },
    restaurants_percentage: {
      label: 'Porcentaje de restaurantes',
    },
    crossed_sales_level: {
      label: 'Nivel de ventas superado',
    },
    order_method: {
      label: 'Método de pedido',
    },
    own_delivery: {
      label: 'Entrega propia',
    },
    only_pickup: {
      label: 'Solo recogida',
    },
    storefront: {
      label: 'Tienda en línea',
    },
    sales_tiers: {
      label: 'Niveles de ventas',
    },
    new_pricing_adoption_rate: {
      label: 'Tasa de adopción del nuevo precio',
    },
    mobile_app_attach_rate: {
      label: 'Tasa de vinculación de app móvil',
    },
    mobile_app_setup_fee_breakdown: {
      label: 'Tarifas de configuración de app móvil elegidas',
    },
    first_delivery: {
      label: 'Uber (Primera entrega)',
    },
    wolt_drive: {
      label: 'Wolt',
    },
    uber_drive: {
      label: 'Uber',
    },
    delivery_quotes_count: {
      label: 'Cantidad de cotizaciones de entrega',
    },
    deliveries_count: {
      label: 'Cantidad de entregas',
    },
    delivery_conversion: {
      label: 'Tasa de conversión de entregas',
    },
    delivery_quotes_provider_breakdown: {
      label: 'Desglose de cotizaciones por proveedor',
    },
    deliveries_provider_breakdown: {
      label: 'Desglose de entregas por proveedor',
    },
    delivery_distance_breakdown: {
      label: 'Desglose por distancia de entrega',
    },
    total_delivered: {
      label: 'Mensajes entregados',
    },
    website_visitors_from_google_business_profile: {
      label: 'Clics en sitio web desde Google Business',
    },
    google_business_impressions: {
      label: 'Impresiones de Google Business',
    },
    google_business_website_clicks: {
      label: 'Clics en sitio web desde Google Business',
    },
    google_ads_impressions: {
      label: 'Impresiones Google Ads',
    },
    google_ads_clicks: {
      label: 'Clics Google Ads',
    },
    google_ads_phone_calls: {
      label: 'Llamadas Google Ads',
    },
    google_ads_directions: {
      label: 'Direcciones Google Ads',
    },
    google_ads_absolute_top_impression_percentage: {
      label: '% promedio de impresión absoluta superior Google Ads',
    },
    google_ads_average_cpc: {
      label: 'Costo promedio por clic Google Ads',
    },
    google_ads_conversions_from_interactions_rate: {
      label: 'Tasa media de conversiones por interacción Google Ads',
    },
    website_visits: {
      label: 'Visitas al sitio web',
    },
    website_visitors: {
      label: 'Visitantes del sitio web',
    },
    companies_with_activated_reservations: {
      label: 'Restaurantes con reservas activadas',
    },
    online_orders_count: {
      label: 'Pedidos en línea',
    },
    cash_orders_count: {
      label: 'Pedidos en línea',
    },
    cash_sales: {
      label: 'Ventas en efectivo',
    },
    online_sales: {
      label: 'Ventas en línea',
    },
    payouts: {
      label: 'Pagos',
    },
    last_payout_amount: {
      label: 'Último pago',
    },
    pending_payout_amount: {
      label: 'En tránsito',
    },
    future_payout_amount: {
      label: 'Disponible para futuros pagos',
    },
    mobile_app_average_order_value: {
      label: 'AOV vía app',
    },
    mobile_app_gmv: {
      label: 'Ventas totales vía app',
    },
    mobile_app_gmv_percentage: {
      label: '% de ingresos vía app',
    },
    mobile_app_downloads: {
      label: 'Total de descargas de app',
    },
    mobile_app_orders_count: {
      label: 'Total de pedidos vía app',
    },
    net_billed_revenue_gift_cards: {
      label: 'Ingresos facturados por tarjetas de regalo',
    },
    gross_cash_income_gift_cards: {
      label: 'Ingresos en efectivo por tarjetas de regalo',
    },
    net_cash_income_gift_cards: {
      label: 'Ingresos en efectivo por tarjetas de regalo',
    },
    platform_processing_fees: {
      label: 'Tarifas de procesamiento de plataforma',
    },
  },
};
